class FirehawkCheckoutConfirmation {
	cartId = null;
	container = null;
	documentElement = null;
	loadingElement = null;
	documentId = null;
	htmlContent = "";

	quoteId = null;
	cart = null;

	objects = [];

	extraParams = {};

	constructor(cartId, documentId, element) {
		this.cartId = cartId
		this.documentId = documentId
		this.container = element
		this.documentElement = jQuery(element).find(".html-content")
		this.loadingElement = jQuery(`<div class="document-loader scale-in-center"><div class="firehawk-crm-search-spinner primary xl"></div></div>`)
	}

	hideLoading() {
		this.loadingElement.remove()
	}

	showLoading() {
		this.documentElement.before(this.loadingElement)
	}

	fetchDocument() {
		if (!this.documentId) {
			return
		}

		this.showLoading()

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'fetch_html_document',
				params: {
					document: this.documentId,
					objects: this.objects || [],
					configDetails: {
						params: this.extraParams || {}
					}
				}
			}
		}).done((response) => {
			var results = JSON.parse(response)

			if (!results || !results.html) {
				this.htmlContent = ""
				this.documentElement.html(this.htmlContent)
				this.hideLoading()
				return
			}

			this.htmlContent = results.html
			this.documentElement.html(this.htmlContent)
			this.hideLoading()
		}).fail((error) => {
			console.error(error)
			this.hideLoading()
		})
	}

	refresh() {
		this.fetchDocument()
	}

	initialise() {
		if (this.quoteId) {
			this.objects.push({
				key: this.quoteId,
				route: "quotes/list/",
				tag: "quote"
			})
		}
		
		this.fetchDocument()
	}
}
